import React, { useEffect } from 'react';
import { useMeritEngineNavigation } from './useMeritEngineNavigation';
import ModDas from './ModDas';
import ModGridcoPriceAnalysis from './ModDashboard/LoadPrice';
import GridcoFileUploadTabComponent from './Resource/Upload/Upload';
import ModGridcoChartTable from './Mod/ModTable/ModIndex';
import GridcoSellBidTable from './Bid/BidIndex';
import ModGridcoSimulationIndex from './ModSimulation/ModSimulationIndex';
import ModGridcoArchive from './ModArchive/ModArchive';
import { getModSession } from "../../../Rest_api/RestApi";
import { ModGridcoSelectedDate } from "../../../store/state/ModGridco/ModDate";
import { setModGridcoSession } from "../../../store/state/ModGridco/ModSession";
import { setModGridcoVersion } from "../../../store/state/ModGridco/ModVersion";
import { setModGridcoSessionToken } from '../../../store/state/ModGridco/ModSessionToken';
import { useDispatch } from "react-redux";

const MeritEngineRouter: React.FC = () => {
  const { currentPage } = useMeritEngineNavigation();
  const dispatch = useDispatch();

  // useEffect to handle page refresh and navigation
  // useEffect(() => {
  //   // This component only renders when currentPage is 'dashboard' or null/undefined
  //   // The MeritEngineRouter handles rendering other pages
  //   // console.log('ModDas rendered with currentPage:', currentPage);
  // }, [currentPage]);

   useEffect(() => {
      async function ModSession() {
        const data = await getModSession();
        if (data) {
          dispatch(ModGridcoSelectedDate(data.date));
          dispatch(setModGridcoSession(data.session));
          dispatch(setModGridcoVersion(data.version));
          dispatch(setModGridcoSessionToken(data.session_token));
        }
      }
      ModSession();
    }, [dispatch]);
  // Render the appropriate component based on the current page
  const renderPage = () => {
    switch (currentPage) {
      case 'load-price':
        return <ModGridcoPriceAnalysis />;
      case 'resources':
        return <GridcoFileUploadTabComponent />;
      case 'merit-order-dispatch':
        return <ModGridcoChartTable />;
      case 'bid':
        return <GridcoSellBidTable />;
      case 'simulation-generation':
        return <ModGridcoSimulationIndex />;
      case 'archive':
        return <ModGridcoArchive />;
      case 'dashboard':
      case null:
      case undefined:
      default:
        return <ModDas />;
    }
  };

  return <>{renderPage()}</>;
};

export default MeritEngineRouter;
